import {
    FinancialDocument,
    ImporterErrors,
    SpreadsheetImporterStatus,
} from "../../common/types/financialDocument";
import { IntegrationAccount } from "../../common/types/integrationAccount";
import { ImporterDocumentImportStatus, ImporterDocumentRow } from "./types";

const IMPORT_COMPLETED_STATUSES = [
    SpreadsheetImporterStatus.IMPORT_SUCCESS,
    SpreadsheetImporterStatus.IMPORT_FAILED,
    SpreadsheetImporterStatus.NEEDS_VERIFICATION,
];

export const IMPORTER_ERROR_MESSAGES: Record<ImporterErrors, string> = {
    [ImporterErrors.NOT_RECONCILED]:
        "Transactions do not reconcile to change in balance",
    [ImporterErrors.NOT_CONFIDENT]: "No discrepancy but want 2nd opinion",
    [ImporterErrors.FOREIGN_CURRENCY]: "Contains foreign currency",
};

export function isTransactionsProcessingFinished(document: FinancialDocument) {
    return IMPORT_COMPLETED_STATUSES.includes(
        document.spreadsheetImporterStatus,
    );
}

export function documentBeingProcessed(document: FinancialDocument) {
    return (
        !document.accountInfoExtracted ||
        !isTransactionsProcessingFinished(document)
    );
}

export function isAccountDataPresent(integrationAccount: IntegrationAccount) {
    return Boolean(
        integrationAccount.originalFinancialAccountId ??
            ((integrationAccount.originalAccountNumber !== null ||
                integrationAccount.originalAccountName) &&
                integrationAccount.originalFinancialType &&
                integrationAccount.originalEntityId &&
                integrationAccount.originalInstitutionName),
    );
}

export function isRowReadyForImport(row: ImporterDocumentRow): boolean {
    const integrationAccount = row.integrationAccount;
    const financialDocument = row.financialDocument;

    if (
        !integrationAccount ||
        !financialDocument ||
        row.importStatus === ImporterDocumentImportStatus.FINISHED
    ) {
        return false;
    }

    const accountDataPresent = isAccountDataPresent(integrationAccount);

    return Boolean(
        accountDataPresent &&
            financialDocument.numTransactions &&
            !financialDocument.importerErrors?.length,
    );
}
